/* eslint-disable no-restricted-syntax */
/* eslint-disable no-case-declarations */
/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
/* eslint-disable array-callback-return */

import Database from 'database';
import api from 'api';
import moment from 'moment';
import Helpers from 'shared/helpers';

import { Types } from 'store/ducks/queue';

const requestSyncTable = async (table, counter = 3) => {
  try {
    return await api.get(`/${table}`);
  } catch (e) {
    if (e.response) {
      switch (e.response.status) {
        case 429:
          await new Promise(res =>
            setTimeout(
              res,
              ((e.response.headers['retry-after'] || 0) + 1) * 1000,
            ),
          );
          return requestSyncTable(table);
        default:
          if (counter > 0) {
            await new Promise(res => setTimeout(res, 1000));
            return requestSyncTable(table, counter - 1);
          }
          throw e;
      }
    } else {
      throw e;
    }
  }
};

export const synchroniseTable = async (table, dispatch) => {
  try {
    const response = await requestSyncTable(table);
    await Database[table].clear();
    await Database[table].bulkPut(response.data);
    if (table === 'pems') {
      for (const tab of ['etapas', 'impactos', 'produtos']) {
        const resp = await requestSyncTable(tab);
        await Database[tab].clear();
        await Database[tab].bulkPut(resp.data);
      }
    }
    const syncUpdate = await api.put('/sync', {
      [table]: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    const prevSync = (await Database.syncs.toCollection().first()) || {};
    await Database.syncs.put({
      ...prevSync,
      [table]: syncUpdate.data[table] || JSON.parse(syncUpdate.config.data)[table], 
      etapas: null,
    });
    dispatch({
      type: Types.SYNC_REGISTRY_UPDATE,
      payload: { [table]: syncUpdate.data[table] || JSON.parse(syncUpdate.config.data)[table] },
    });
  } catch (oof) {
    if (oof && oof.response && oof.response.status) {
      if (oof.response.status === 403) {
        dispatch({
          type: Types.SYNC_REGISTRY_UPDATE,
          payload: { [table]: moment().format('YYYY-MM-DD HH:mm:ss') },
        });
      }
    }
  }
};

const sendRequest = async (route, method, ref, localIds, controller, counter = 3) => {
  try {
    const response = await api[method](
      `/${controller.array[0].url || controller.array[0].table}`,
      controller.array[0].requestBody,
    );
    const data =
      response.data instanceof Array ? response.data : [response.data];

    if (localIds.length !== data.length) {
      console.log(localIds, data);
      throw new Error('Data length mismatch');
    }

    if (controller.array[0].table === 'produtos') {
      await updateLocalEntity('produtos', localIds, data);
    }

    return () =>
      fixDependencies(
        controller.array[0].table,
        localIds,
        ref,
        data,
        controller.array,
      );
  } catch (oof) {
    if (oof) {
      if (oof.response) {
        switch (oof.response.status) {
          case 404:
            const [route2, body] = redec(route, controller.array[0]);

            try {
              const response = await api.post(`/${route2}`, body);
              const data =
                response.data instanceof Array
                  ? response.data
                  : [response.data];

              return () =>
                fixDependencies(
                  controller.array[0].table,
                  localIds,
                  ref,
                  data,
                  controller.array,
                );
            } catch (oof) {
              // Catch network errors
              throw oof;
            }
          case 429:
            await Promise(res =>
              setTimeout(res, (oof.response.headers['retry-after'] + 1) * 1000),
            );
            return sendRequest(route, method, ref, localIds, controller);
          default:
            if (counter > 0) {
              await new Promise(res => setTimeout(res, 1000));
              return sendRequest(route, method, ref, localIds, controller, counter - 1);
            }
            throw oof;
        }
      }
    }
    throw oof;
  }
};

/**
 * 
 * @param {*} queue 
 * @returns {Promise<boolean>} Should sync itens again
 */
export const sendQueue = async queue => {
  const forceUpdate = queue.length;
  let currentControllerArray;
  try {
    await Helpers.asyncForEach(
      queue,
      async controller => {
        currentControllerArray = controller.array;
        await Database.queue.bulkDelete(queue.map(q => q._id));
        await Database.queue.bulkPut(controller.array);
        const [route, method, ref, localIds] = decode(controller.array[0]);
        return sendRequest(route, method, ref, localIds, controller);
      },
      {
        forceControl: true,
        exhaustArray: true,
        done: async () => {
          if (queue.length > 0) {
            await Database.queue.bulkDelete(queue.map(q => q._id));
          }
        },
      },
    );
  } catch (e) {
    console.error('Ocorreu um erro inesperado na comunicação, mantendo os dados da queue', e);
    e.queue = currentControllerArray;
    throw e;
  }
  return forceUpdate;
};

const updateLocalEntity = async (table, localIds, entities) => {
  for (let i = 0; i < localIds.length; i++) {
    const localEntity = await Database[table].get(localIds[i]);
    if (localEntity) {
      await Database[table].update(localIds[i], { ...entities[i] });
    }
  }
};

/**
 * This should be used to handle requests responses that should affects next requests like
 * for example product creation, that has a local instance with a Fake ID
 * and when synchronized, this instance will get a real id and should update it`s references
 * on the next calls, like the etapas call that can reference an uncreated product
 * @param {*} table 
 * @param {*} localIds The local instances ids
 * @param {*} ref 
 * @param {*} data The response object
 * @param {*} queue 
 */
const fixDependencies = (table, localIds, ref, data, queue) => {
  const urlMatches = ({ x, i }, keys) =>
    x.url &&
    x.url.split('/').length === 2 &&
    keys.includes(x.url.split('/')[0]) &&
    x.url.split('/')[1] === String(localIds[i]);

  const bodyMatches = ({ x, i }, ref) =>
    x.requestBody[ref] && String(x.requestBody[ref] === String(localIds[i]));

  const bodyIncludes = ({ x, i }, ref) =>
    x.requestBody[ref] &&
    Object.values(x.requestBody[ref]).find(
      y => String(y) === String(localIds[i]),
    );

  if (localIds.length === 0) {
    return queue.slice(1);
  }

  for (let i = 0; i < localIds.length; i++) {
    switch (table) {
      case 'pems':
        queue.filter((x, y, a) => {
          if (
            urlMatches({ x, i }, [
              'respostas',
              'etapas',
              'impactos',
              'produtos',
            ])
          ) {
            a[y] = {
              ...x,
              url: x.url.split('/')[0] + `/${data[i].id}`,
            };
          }
          if (bodyMatches({ x, i }, ref)) {
            a[y] = {
              ...x,
              requestBody: {
                ...x.requestBody,
                [ref]: data[i].id,
              },
            };
          }
        });
        return queue.slice(1);
      case 'etapas':
        queue.filter((x, y, a) => {
          // If the body contains the etapa_id
          if (bodyIncludes({ x, i }, ['etapa_id'])) {
            // Updated the item from the queue
            a[y] = {
              // The data already on the queue
              ...x,
              // Override the request body
              requestBody: {
                // With the already set request body
                ...x.requestBody,
                // Udates the etapa_id
                etapa_id: {
                  // The current etapa_id list
                  ...Object.entries(x.requestBody.etapa_id).reduce((r, [ordem, id]) => {
                    if (id === localIds[i]) {
                      r[ordem] = ((data || [])
                        .find(respEtapa =>
                          String(respEtapa.ordem) === String(ordem),
                        ) || {}).id;
                    } else {
                      r[ordem] = id;
                    }
                    return r;
                  }, {}),
                },
              },
            };
          }
        });
        if (i === localIds.length - 1) {
          return queue.slice(1);
        }
        break;
      case 'produtos':
        queue.filter((x, y, a) => {
          if (urlMatches({ x, i }, ['produtos'])) {
            a[y] = {
              ...x,
              url: x.url.split('/')[0] + `/${data[i].id}`,
            };
          }

          if (bodyMatches({ x, i }, ref)) {
            a[y] = {
              ...x,
              requestBody: {
                ...x.requestBody,
                [ref]: data[i].id,
              },
            };
          }

          if (
            x.url &&
            x.url.split('/')[0] === 'etapas' &&
            Object.values(x.requestBody.produtos).find(produtosEtapa =>
              Object.values(produtosEtapa)
                .map(String)
                .includes(String(localIds[i])),
            )
          ) {
            a[y] = {
              ...x,
              requestBody: {
                ...x.requestBody,
                produtos: {
                  ...Object.entries(x.requestBody.produtos).reduce(
                    (result, [key, produtosEtapa]) => ({
                      ...result,
                      [key]: Object.entries(produtosEtapa).reduce(
                        (result, [key, value]) => ({
                          ...result,
                          [key]:
                            String(value) === String(localIds[i])
                              ? data[i].id
                              : value,
                        }),
                        {},
                      ),
                    }),
                    {},
                  ),
                },
              },
            };
          }
        });

        return queue.slice(1);
      default:
        return queue.slice(1);
    }
  }
};

const methodsMap = {
  'respostas/': 'post',
  pems: 'post',
  produtos: 'post',
};

const decode = item => {
  let route = item.url || item.table;
  route = route.includes('/') ? route.split('/')[0] + '/' : route;

  const method = methodsMap[route] || 'put';

  let ref =
    item.table.substring(item.table.length - 1) === 's'
      ? item.table.substring(0, item.table.length - 1)
      : item.table;
  ref += '_id';

  const localIds =
    item.localId instanceof Array ? item.localId : [item.localId];

  return [route, method, ref, localIds];
};

const redec = (route, item) => {
  const pathPieces = route.split('/');
  if (
    pathPieces instanceof Array &&
    ['impactos', 'etapas'].includes(pathPieces[0])
  ) {
    item.requestBody.pem_id = item.url.split('/')[1];
  }
  return [pathPieces[0], item.requestBody];
};
